import { Injectable, group } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import * as io from 'socket.io-client';
import { Subject } from 'rxjs/Subject';
import { GameObject, DraftPick } from 'app/models/draft';
import { GroupObject } from 'app/models/group';
import { UserService } from 'shared/services/User/user.service';
import { MatDialog } from '@angular/material';
import { GroupService } from 'shared/services/SS-Groups/groups.service';
import { UIService } from 'shared/services/UI/ui.service';
import { environment } from 'environments/environment';

@Injectable()
export class DraftService {
    url = environment.NODE_DRAFTER_URL;
    socket = io(this.url, {
        transports: ['polling', 'websocket']
    });

    CURRENT_GROUP: GroupObject;

    // SUBSCRIPTIONS
    UPDATED_PICK: any;
    myResultsArray: any = [];
    /* presentMembers$: Subject<any> = new Subject(); // array of uids */
    /* draftStarted$: Subject<any> = new Subject(); // boolean */
    timerEvent$: Subject<any> = new Subject(); // boolean
    /* status$: Subject<any> = new Subject(); */
    error$: Subject<any> = new Subject();

    queueGameListTest$ = new Subject<any[]>();
    draftPickSubscription$ = new Subject<any[]>();
    pickedTicketSubscription$ = new Subject<any>();
    draftCompletedSubscription$ = new Subject<any>();
    yourResultsSubscription$ = new Subject<any>();
    myTurnSubscription$ = new Subject<any>();
    queueGameList$ = new Subject<any[]>();

    yourTurnToggled: Boolean = false;
    // DRAFT RELATED VARIABLES
    ALL_GAMES;
    AVAILABLE_GAMES: GameObject[];
    DRAFT_PICKS: DraftPick[];
    CURRENT_PICK: DraftPick;
    ROUND_NUMBER;
    PREV_DRAFT_PICK_ID = null;
    DRAFT_STATUS = null;
    RESPONSE_TIMEOUT;
    CONN_TIMEOUT;
    header_timeout;

    // Intervals
    POLLER_INTERVAL;
    TIMER_INTERVAL;

    // COMPONENT DEPENDENCIES
    _TEAM_NAME;
    _COUNTDOWN;
    _IS_DRAFT_COMPLETED: Boolean = false;
    _TIMER_EVENT_STATUS = { status: '', countdown: '', round: '' };

    constructor(
        private gs: GroupService,
        private us: UserService,
        private ui: UIService,
        private dialog: MatDialog
    ) {
        this.socket.on('disconnect', () => {
            this.error$.next('TIMEOUT');
        });

        this.socket.on('reconnect', () => {
            this.socket.sendBuffer = [];
        });
        this.socket.on('connect', () => {
            this.socket.sendBuffer = [];
        });

        this.socket.on('pingSuccess', (data) => {
            alert('PING SUCCESS!');
            const timeOffset = data['time_offset'];
        });

        this.socket.on('join success', (group_id) => {
            clearTimeout(this.CONN_TIMEOUT);
            this.RESPONSE_TIMEOUT = setTimeout(() => {
                this.showTimeoutError();
            }, 6000);
            this.startDraftPoller();
        });

        this.socket.on('draft pick response', data => {
            this.handleDraftPickResponse(data);
        });

        this.socket.on('err', data => {
            this.stopAllPollers();
            this.reconnectDraft();
        });
    }

    // START DRAFT
    startDraft() {
        const data = { uid: this.us.user.uid, group_id: this.gs.currentGroup.group_id, token: this.us.user.token };
        const connectionCheck = setInterval(() => {
            const a = this.socket.connected;
            if (a === true) {
                clearInterval(connectionCheck);
                this.socket.emit('start draft', data);
            }
        }, 800);

        this.CONN_TIMEOUT = setTimeout(() => {
            // stop checking for connection
            clearInterval(connectionCheck);
            this.showTimeoutError();
        }, 8500);
    }

    // DRAFT PICK UPDATE POLLER
    draftPickUpdate = () => {
        if (this.DRAFT_PICKS.length === 0) {
            this.DRAFT_STATUS = 'COMPLETE';
            clearInterval(this.TIMER_INTERVAL);
            this.stopDraftPickUpdatePoller();
            clearInterval(this.header_timeout);
            this._IS_DRAFT_COMPLETED = true;
            this.updateTimerEvent({ status: this.DRAFT_STATUS, countdown: 0 });
            this.toggleResultsTab();
        } else {
            this.CURRENT_PICK = this.DRAFT_PICKS[0];
            this._IS_DRAFT_COMPLETED = false;
            const data = {
                draft_pick_id: this.CURRENT_PICK.draft_pick_id,
                group_id: this.CURRENT_GROUP.group_id,
                client_time: Date.now()
            };
            if (data.draft_pick_id && data.group_id) {
                this.socket.emit('draft pick update', data);
            }
        }
    }

    stopDraftPickUpdatePoller() {
        clearInterval(this.POLLER_INTERVAL);
        this.POLLER_INTERVAL = false;
    }

    stopAllPollers() {
        clearInterval(this.POLLER_INTERVAL);
    }

    // DRAFT PICK RESPONSE
    handleDraftPickResponse(data) {
        if (data.drafted_game_id_fk) {
            clearTimeout(this.RESPONSE_TIMEOUT);
            this.handleDraftingResponse(data);
        } else {
            // its a queue object
            if (data.draft_status === 'QUEUE') {
                clearTimeout(this.RESPONSE_TIMEOUT);
                if (this.DRAFT_STATUS !== 'QUEUE') {
                    this.DRAFT_STATUS = 'QUEUE';
                    this.ROUND_NUMBER = '';
                    this.startTimerByEndStamp(data.end_tstamp);
                }
            }
        }
    }

    handleDraftingResponse(data) {
        if (this.currentlyDrafting(data)) {
            // we're drafting
            this.DRAFT_STATUS = 'DRAFT PICK IN';
            this.UPDATED_PICK = data;
            // ticket was picked
            if (data.drafted_game_id_fk !== '0' && (this.UPDATED_PICK.draft_pick_id === this.CURRENT_PICK.draft_pick_id)) {
                this.stopTimer();
                this.yourTurnToggled = false;
                // tell component what game id and who drafted it..
                console.log('this.UPDATED_PICK', this.UPDATED_PICK);
                this.displayPickedTicket(this.UPDATED_PICK.drafted_game_id_fk, this.CURRENT_PICK.first_name,
                    this.CURRENT_PICK.last_name, this.CURRENT_PICK.thumb_img);
                this.DRAFT_PICKS.shift();
                this.CURRENT_PICK = this.DRAFT_PICKS[0];
                this.draftPickSubscription$.next(this.DRAFT_PICKS);
                setTimeout(() => {
                    this.removeGameByID(data.drafted_game_id_fk);
                    this.updateYourResults();
                }, 2500);
            }
            // new turn started
            if ((this.PREV_DRAFT_PICK_ID !== this.UPDATED_PICK.draft_pick_id) && this.UPDATED_PICK.end_tstamp !== '0') {
                this.startTimerByEndStamp(data.end_tstamp); // NOTE - node is saving end tstamp in start stamp place
                this.DRAFT_PICKS[0]['current'] = true;
                this.draftPickSubscription$.next(this.DRAFT_PICKS);
                this.PREV_DRAFT_PICK_ID = this.CURRENT_PICK.draft_pick_id;
                // and its your turn
                if (this.DRAFT_PICKS[0].uid === this.us.user.uid && this.UPDATED_PICK.draft_pick_id === this.CURRENT_PICK.draft_pick_id) {
                    this.toggleYourTurn(true);
                }
            }
        }
    }

    // START A TIMER BY END STAMP RECIEVED
    startTimerByEndStamp(endStamp) {
        this.ui.emitLoaderState(false);
        let countdown = (Number(endStamp) - Math.floor(Date.now() / 1000));
        this._COUNTDOWN = countdown;
        this.updateTimerEvent({ status: this.DRAFT_STATUS, countdown: countdown, round: this.DRAFT_PICKS[0].round_number });
            this.TIMER_INTERVAL = setInterval(() => {
                countdown--;
                if (countdown <= 0) {
                    this.dialog.closeAll();
                    clearInterval(this.TIMER_INTERVAL);
                    this.yourTurnToggled = false;
                }
                if (this.DRAFT_PICKS[0] !== undefined) {
                    this.updateTimerEvent({ status: this.DRAFT_STATUS, countdown: countdown, round: this.DRAFT_PICKS[0].round_number });
                }
            }, 1000);
    }

    // STOP THE TIMER ON A MANUAL DRAFT PICK
    stopTimer() {
        clearInterval(this.TIMER_INTERVAL);
        this.dialog.closeAll();
        this.updateTimerEvent({ status: this.DRAFT_STATUS, countdown: 0, round: this.DRAFT_PICKS[0].round_number });
    }

    // MANUALLY SELECT A GAME
    draftGame(game: GameObject) {
        const data = {
            uid: this.us.user.uid,
            game_id: game.game_id,
            draft_pick_id: this.DRAFT_PICKS[0].draft_pick_id,
            group_id: this.CURRENT_GROUP.group_id
        };
        this.socket.emit('draft game', data);
    }

    updateUserQueueArray(GAMES) {
        this.queueGameListTest$.next(GAMES);
    }

    // Called by draft header, return array of pending picks.
    componentJoinedDraft(group_id) {
        this.DRAFT_STATUS = null;
        /*  this.resetTimerEvent(); */
        // set up local variables,
        const result = new Promise((resolve, reject) => {
            this.gs.refreshGroup(group_id).subscribe(groupObject => {
                this.CURRENT_GROUP = groupObject;
                this._TEAM_NAME = this.CURRENT_GROUP.season_ticket.team;
                this.ALL_GAMES = this.CURRENT_GROUP.season_ticket.games;
                this.setGamePool(this.CURRENT_GROUP.season_ticket.games);
                // set draft picks.
                this.DRAFT_PICKS = this.CURRENT_GROUP.group_draft_picks.filter(onePick => {
                    return onePick.drafted_game_id_fk === '0';
                });
                resolve(this.DRAFT_PICKS);
                this.draftPickSubscription$.next(this.DRAFT_PICKS);
            }, err => {
                reject(err);
            });
        });
        return result;
    }

    startDraftPoller() {
        if (!this.POLLER_INTERVAL) {
            this.POLLER_INTERVAL = setInterval(() => {
                this.draftPickUpdate();
            }, 700);
        }
    }

    queueGame(game) {
        const data = {
            group_id: this.CURRENT_GROUP.group_id,
            gameData: {
                uid: this.us.user.uid,
                game_id: game.game_id,
                isQueued: game.isQueued
            }
        };
        this.socket.emit('queue game', data);
    }

    displayPickedTicket(gameID, firstName, lastName, img) {
        /*  const index: any = this.ALL_GAMES.findIndex((oneGame) => {
             return oneGame.game_id === gameID;
         }); */
        const choserName = firstName + ' ' + lastName;
        this.pickedTicketSubscription$.next({ game_id: gameID, name: choserName, thumb_img: img });
        /* this.pickedTicketSubscription$.next({ game_id: gameID, name: choserName,
            thumb_img: img, game: this.ALL_GAMES[Number(index)] }); */
    }

    toggleResultsTab() {
        this.draftCompletedSubscription$.next(true);
    }

    updateYourResults() {
        this.gs.refreshGroup(this.CURRENT_GROUP.group_id).subscribe(groupObject => {
            const a = groupObject.season_ticket.games.filter(x => x.owned_by_uid_fk === this.us.user.uid);
            this.myResultsArray = a;
            this.yourResultsSubscription$.next(a);
        });
    }

    toggleYourTurn(onOff) {
        if (this.yourTurnToggled) {
            // do nothing
        } else {
            if (onOff) {
                this.yourTurnToggled = true;
                this.myTurnSubscription$.next(true);
            } else {
                this.yourTurnToggled = false;
                this.myTurnSubscription$.next(false);
            }
        }
    }

    updateTimerEvent(data) {
        this._TIMER_EVENT_STATUS = data;
        this.timerEvent$.next(data);
    }

    resetTimerEvent() {
        clearTimeout(this.header_timeout);
        clearInterval(this.TIMER_INTERVAL);
        this.PREV_DRAFT_PICK_ID = null;
        this.CURRENT_PICK = null;
        this.stopDraftPickUpdatePoller();
        this._TIMER_EVENT_STATUS = { status: '', countdown: '', round: '' };
        this._IS_DRAFT_COMPLETED = false;
    }

    reconnectDraft() {
        this.DRAFT_STATUS = 'RECONNECT';
        // set member variables to null
        this.AVAILABLE_GAMES = null;
        alert('Reconnecting the draft');
        this.componentJoinedDraft(this.CURRENT_GROUP.group_id).then(res => {
            // promise returns draft picks
            this.startDraftPoller();
        }, err => {
            // on error
        });
    }

    setGamePool(gamePoolArray) {
        const newArray = gamePoolArray.filter(element => {
            return (element.owned_by_uid_fk === '0' || element.owned_by_uid_fk == null);
        });
        this.AVAILABLE_GAMES = newArray;
        if (this.AVAILABLE_GAMES.length === 0) {
            this.DRAFT_STATUS = 'COMPLETE';
        }
        this.queueGameList$.next(this.AVAILABLE_GAMES);
    }

    removeGameByID(draftedGameID) {
        const obj: GameObject = this.AVAILABLE_GAMES.find((obj1) => {
            return obj1.game_id === draftedGameID;
        });
        const a = this.AVAILABLE_GAMES.indexOf(obj);
        this.AVAILABLE_GAMES.splice(a, 1);
        this.queueGameList$.next(this.AVAILABLE_GAMES);
        this.queueGameListTest$.next(this.AVAILABLE_GAMES);
    }

    getAvailableGames() {
        return this.AVAILABLE_GAMES;
    }

    getTeamName() {
        return this._TEAM_NAME;
    }

    currentlyDrafting(updatedPick) {
        if (updatedPick.start_tstamp === '') {
            return false;
        }
        if (updatedPick.draft_pick_id == null) {
            return false;
        }
        if (updatedPick.draft_status) {
            return false;
        }
        if (this.DRAFT_PICKS[0] === undefined) {
            return false;
        }

        if (updatedPick.uid === this.us.user.uid && updatedPick.draft_pick_id === this.CURRENT_PICK.draft_pick_id) {
            this.toggleYourTurn(true);
            return true;
        }
        return true;
    }

    showTimeoutError() {
        this.error$.next('TIMEOUT');
        this.stopDraftPickUpdatePoller(); // stop the poller
    }

    // CALLED - If header is stuck for more than 7500ms
    forceRefresh() {
        this.error$.next('FORCE');
        clearInterval(this.TIMER_INTERVAL);
        this.stopDraftPickUpdatePoller();
        this._TIMER_EVENT_STATUS = { status: '', countdown: '', round: '' };
        this.PREV_DRAFT_PICK_ID = null;
        this.UPDATED_PICK = null;
        this.CURRENT_PICK = null;
        this.yourTurnToggled = false;
        this.AVAILABLE_GAMES = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/draft/services/draft.service.ts